define('InventoryStockLocation', [
		'InventoryStockLocation.View',
		'jQuery'
	]
,   function (
		InventoryStockLocationView,
		jQuery
	)
{
	'use strict';
	
	return  {
		mountToApp: function mountToApp (container)
		{
			/** @type {LayoutComponent} */
			var pdp = container.getComponent('PDP');


			if (pdp){
				pdp.addChildViews(pdp.PDP_FULL_VIEW, {
					'Quantity.Pricing': {
						'InventoryStockLocationView': {
							childViewIndex: 10,
							childViewConstructor: function childViewConstructor() {
								return new InventoryStockLocationView({
									pdp: pdp,
									container: container
								});
							}
						}
					}
				});

				pdp.addChildViews(pdp.PDP_QUICK_VIEW, {
					'Quantity.Pricing': {
						'InventoryStockLocationView': {
							childViewIndex: 10,
							childViewConstructor: function childViewConstructor() {
								return new InventoryStockLocationView({
									pdp: pdp,
									container: container
								});
							}
						}
					}
				});
			}

		}
	};
});
